<template>
    <tr v-if="(discount as Discount).amount > 0">
        <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4 tw-pl-10 tw-pl-10">
        <span class="tw-mr-5 tw-inline-block">
            {{(discount as Discount).description}}
        </span>
        <TwButton 
            cssClass="tw-bg-transparent hover:tw-text-orange-medium tw-transition-all tw-duration-200 tw-inline-block" 
            @emit-click="clickedRemoveDiscount(discount as Discount)" 
            :isLoading="processingRemove"
            :isDisabled="false" 
            buttonText="remove"/>

        </td>
        <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
        -${{(discount as Discount).amount ? (discount as Discount).amount.toLocaleString("en-US", {minimumFractionDigits: 2}) : '0.00'}}
        </td>
    </tr>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'

// Data
import { useBasketStore } from "../../stores/basket";
import { useUserStore } from '../../stores/user';
import type Discount from '../../types/Discount';

const props = defineProps<{ discount: Discount }>();

import TwButton from '../../components/TwButton.vue';

const emit = defineEmits(['emitRemoveDiscount', 'emitRemoveDiscount'])

const processingRemove = ref(false);

const clickedRemoveDiscount = (discount: Discount) => {
  processingRemove.value = true
  emit('emitRemoveDiscount', discount)
}

</script>